// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__hGgSN","content":"Alert_content__FY3m5"};